// extracted by mini-css-extract-plugin
export default {"main":"ZoomControl_main__t904n","container":"ZoomControl_container__NCDu5"};